import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';
import Input from '../ui/Input';

const PublicHeader = ({ onSearch, searchValue = '', onSearchChange, notificationCount = 0 }) => {
  const navigate = useNavigate();
  const [isSearchExpanded, setIsSearchExpanded] = useState(false);

  const handleSearchToggle = () => {
    setIsSearchExpanded(!isSearchExpanded);
  };

  const handleSearchSubmit = (e) => {
    e?.preventDefault();
    if (onSearch && searchValue?.trim()) {
      onSearch(searchValue);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-1000 bg-card shadow-md transition-smooth">
      <div className="flex items-center justify-between h-16 px-4 md:px-6">
        <div className="flex items-center gap-3">
          <div className="flex items-center justify-center w-10 h-10 bg-primary/10 rounded-lg transition-smooth hover:bg-primary/20">
            <Icon name="Bus" size={24} color="var(--color-primary)" />
          </div>
          <h1 className="text-xl font-bold text-foreground font-heading hidden sm:block">
            Konya Dolmuş Saatim
          </h1>
        </div>

        <div className="flex items-center gap-2">
          <div className={`transition-smooth ${isSearchExpanded ? 'w-64' : 'w-0 md:w-64'} overflow-hidden`}>
            <form onSubmit={handleSearchSubmit}>
              <Input
                type="search"
                placeholder="Rota ara..."
                value={searchValue}
                onChange={(e) => onSearchChange && onSearchChange(e?.target?.value)}
                className="w-full"
              />
            </form>
          </div>

          {/* Notification Badge */}
          <div className="flex items-center gap-1">
            {notificationCount > 0 && (
              <div className="relative flex items-center justify-center w-10 h-10 rounded-lg bg-primary/10 hover:bg-primary/20 transition-smooth">
                <Icon name="Bell" size={20} color="var(--color-primary)" />
                <span className="absolute -top-1 -right-1 flex items-center justify-center w-5 h-5 text-xs font-bold text-white bg-red-500 rounded-full">
                  {notificationCount > 9 ? '9+' : notificationCount}
                </span>
              </div>
            )}
          </div>

          <button
            onClick={handleSearchToggle}
            className="md:hidden flex items-center justify-center w-10 h-10 rounded-lg bg-muted hover:bg-muted/80 transition-smooth active-press"
            aria-label="Arama"
          >
            <Icon name={isSearchExpanded ? "X" : "Search"} size={20} color="var(--color-foreground)" />
          </button>
        </div>
      </div>
    </header>
  );
};

export default PublicHeader;